export default __webpack_public_path__ + "media/images/images/banner/banner-4-ec79b02ad5c86421fc812a2b21d9ba1f.jpg";